import { c as _c } from "react/compiler-runtime";
import Box from '@mui/material/Box';
import * as colors from '@mui/material/colors';
import Link from '@mui/material/Link';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import { useHash } from '@shared/hooks/useHash';
import { useWindowResize } from '@shared/hooks/useWindowResize';
import { useWindowScroll } from '@shared/hooks/useWindowScroll';
import { ROUTES } from '@shared/routes';
import { TOP_BAR_HEIGHT } from '@shared/theme';
import { useCallback, useState } from 'react';
import LinearProgress from '@mui/material/LinearProgress';
export const ROOT_CONTAINER_ID = 'root-container';
const BREADCRUMB_HEIGHT = 65;
const MIN_WIDTH = 150;
const getBackgroundColor = (theme, isActive, isSecondary) => {
  if (isActive) {
    return isSecondary ? theme.palette.primary.altern : theme.palette.primary.dark;
  }
  return isSecondary ? theme.palette.primary.light : theme.palette.primary.main;
};
const getTextColor = (isActive, isSecondary) => {
  if (isSecondary) {
    return isActive ? 'white' : 'black';
  }
  return isActive ? 'secondary.main' : 'white';
};
const getHoverTextColor = isSecondary => {
  return isSecondary ? 'white' : 'secondary.main';
};
const getProgressColor = completedPct => {
  if (completedPct >= 51) return 'success';
  if (completedPct > 0) return 'warning';
  return undefined;
};
const getProgressTextColor = completedPct => {
  if (completedPct >= 51) return '#388e3c';
  if (completedPct > 0) return '#e65100';
  return '#9e9e9e';
};
const ListNavItem = t0 => {
  const $ = _c(36);
  const {
    children,
    isActive,
    isSecondary,
    remainingRunFraction,
    onNavigate
  } = t0;
  let T0;
  let T1;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== children || $[1] !== isActive || $[2] !== isSecondary || $[3] !== onNavigate || $[4] !== remainingRunFraction) {
    const completedPct = remainingRunFraction != null ? Math.round((1 - remainingRunFraction) * 100) : null;
    const t8 = isActive ?? false;
    const t9 = isSecondary ?? false;
    let t10;
    if ($[14] !== t8 || $[15] !== t9) {
      t10 = getTextColor(t8, t9);
      $[14] = t8;
      $[15] = t9;
      $[16] = t10;
    } else {
      t10 = $[16];
    }
    const textColor = t10;
    T1 = ListItem;
    t5 = true;
    if ($[17] !== isActive || $[18] !== isSecondary) {
      t6 = theme => ({
        display: "block",
        backgroundColor: getBackgroundColor(theme, isActive ?? false, isSecondary ?? false),
        "&:hover": {
          backgroundColor: isSecondary ? theme.palette.primary.dark : theme.palette.primary.dark
        }
      });
      $[17] = isActive;
      $[18] = isSecondary;
      $[19] = t6;
    } else {
      t6 = $[19];
    }
    t7 = true;
    T0 = ListItemButton;
    t1 = isActive;
    t2 = onNavigate;
    const t11 = isSecondary ?? false;
    let t12;
    if ($[20] !== t11) {
      t12 = getHoverTextColor(t11);
      $[20] = t11;
      $[21] = t12;
    } else {
      t12 = $[21];
    }
    if ($[22] !== t12) {
      t3 = {
        "&:hover": {
          "& .MuiListItemText-primary": {
            color: t12
          }
        }
      };
      $[22] = t12;
      $[23] = t3;
    } else {
      t3 = $[23];
    }
    t4 = completedPct != null ? <Box width="100%" py={0.25}><Box display="flex" justifyContent="space-between" alignItems="center" mb={0.75}><Typography fontWeight={600} color="white" fontSize={14} lineHeight={1.2}>{children}</Typography><Typography fontWeight={700} color={getProgressTextColor(completedPct)} fontSize={13} ml={1} flexShrink={0}>{completedPct}%</Typography></Box><LinearProgress variant="determinate" value={completedPct} color={getProgressColor(completedPct)} sx={{
        height: 6,
        borderRadius: 3,
        backgroundColor: "rgba(0,0,0,0.25)",
        "& .MuiLinearProgress-bar": {
          borderRadius: 3,
          ...(completedPct === 0 && {
            backgroundColor: "rgba(255,255,255,0.3)"
          })
        }
      }} /></Box> : <ListItemText primaryTypographyProps={{
      fontWeight: 500,
      color: textColor,
      fontSize: 14
    }}>{children}</ListItemText>;
    $[0] = children;
    $[1] = isActive;
    $[2] = isSecondary;
    $[3] = onNavigate;
    $[4] = remainingRunFraction;
    $[5] = T0;
    $[6] = T1;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    T0 = $[5];
    T1 = $[6];
    t1 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
  }
  let t8;
  if ($[24] !== T0 || $[25] !== t1 || $[26] !== t2 || $[27] !== t3 || $[28] !== t4) {
    t8 = <T0 selected={t1} onClick={t2} sx={t3}>{t4}</T0>;
    $[24] = T0;
    $[25] = t1;
    $[26] = t2;
    $[27] = t3;
    $[28] = t4;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  let t9;
  if ($[30] !== T1 || $[31] !== t5 || $[32] !== t6 || $[33] !== t7 || $[34] !== t8) {
    t9 = <T1 disablePadding={t5} sx={t6} divider={t7}>{t8}</T1>;
    $[30] = T1;
    $[31] = t5;
    $[32] = t6;
    $[33] = t7;
    $[34] = t8;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  return t9;
};
export const SideNavigationPanel = t0 => {
  const $ = _c(34);
  const {
    title,
    sections,
    children,
    scrollOffset: t1,
    jobId
  } = t0;
  const scrollOffset = t1 === undefined ? 0 : t1;
  const [containerTop, setContainerTop] = useState(BREADCRUMB_HEIGHT + TOP_BAR_HEIGHT);
  const [width, setWidth] = useState(MIN_WIDTH);
  const [currentSection, setCurrentSection] = useState(sections[0]);
  const {
    scrollToSection
  } = useHash();
  const [marginLeft, setMarginLeft] = useState("0px");
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const rootContainer = document.getElementById(ROOT_CONTAINER_ID);
      if (!rootContainer) {
        return;
      }
      const containerMargin = window.getComputedStyle(rootContainer).getPropertyValue("margin-left");
      const containerPadding = window.getComputedStyle(rootContainer).getPropertyValue("padding-left");
      const offset = parseFloat(containerMargin.replace("px", "")) + parseFloat(containerPadding.replace("px", ""));
      setMarginLeft(`-${offset}px`);
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  useWindowResize(t2);
  let t3;
  if ($[1] !== containerTop || $[2] !== scrollOffset || $[3] !== sections) {
    t3 = t4 => {
      const {
        y
      } = t4;
      if (y < BREADCRUMB_HEIGHT) {
        setContainerTop(BREADCRUMB_HEIGHT - y + TOP_BAR_HEIGHT);
      } else {
        setContainerTop(TOP_BAR_HEIGHT);
      }
      const getVisibleSections = () => sections.map((section, index) => {
        const element = document.getElementById(section.id);
        if (!element) {
          return null;
        }
        const {
          top,
          bottom
        } = element.getBoundingClientRect();
        const offset_0 = containerTop + scrollOffset + 2;
        const fullyVisible = top >= offset_0 && bottom <= window.innerHeight;
        const tooTallButActive = top <= offset_0 && bottom > offset_0;
        if (fullyVisible || tooTallButActive) {
          return {
            section,
            index,
            top
          };
        }
        return null;
      }).filter(Boolean);
      const atPageBottom = Math.abs(window.innerHeight + window.scrollY - document.body.scrollHeight) < 2;
      if (atPageBottom) {
        setCurrentSection(sections[sections.length - 1]);
      } else {
        const visibleSections = getVisibleSections();
        if (visibleSections.length < 0) {
          return;
        }
        visibleSections.sort(_temp);
        setCurrentSection(visibleSections?.[0]?.section ?? sections[0]);
      }
    };
    $[1] = containerTop;
    $[2] = scrollOffset;
    $[3] = sections;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  useWindowScroll(t3);
  const t4 = `calc(100vh - ${containerTop}px)`;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = ref => setWidth(ref?.clientWidth ?? 0);
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== jobId || $[7] !== title) {
    t6 = jobId ? <Link href={ROUTES.jobs.show(jobId)} color="inherit" underline="hover" sx={{
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline"
      }
    }}>{title}</Link> : title;
    $[6] = jobId;
    $[7] = title;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t6) {
    t7 = <Typography color="primary.main" bgcolor="white" zIndex={100} textAlign="center" boxShadow={2} fontWeight={600} fontSize={16} py={1.5} borderBottom={`1px solid ${colors.blue[900]}`} borderRight={`1px solid ${colors.grey[300]}`} position="sticky" top={0}>{t6}</Typography>;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== currentSection || $[12] !== scrollOffset || $[13] !== scrollToSection || $[14] !== sections) {
    let t9;
    if ($[16] !== currentSection || $[17] !== scrollOffset || $[18] !== scrollToSection) {
      t9 = section_0 => <ListNavItem key={section_0.id} isActive={currentSection.label === section_0.label && currentSection.id === section_0.id} isSecondary={section_0.isSecondary} remainingRunFraction={section_0.remainingRunFraction} onNavigate={() => scrollToSection(section_0.id, false, scrollOffset)}>{section_0.label}</ListNavItem>;
      $[16] = currentSection;
      $[17] = scrollOffset;
      $[18] = scrollToSection;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    t8 = sections.map(t9);
    $[11] = currentSection;
    $[12] = scrollOffset;
    $[13] = scrollToSection;
    $[14] = sections;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[20] !== t8) {
    t9 = <List dense={true} disablePadding={true}>{t8}</List>;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== containerTop || $[23] !== marginLeft || $[24] !== t4 || $[25] !== t7 || $[26] !== t9) {
    t10 = <Box ml={marginLeft} top={containerTop} minWidth={MIN_WIDTH} height={t4} bgcolor="primary.main" whiteSpace="nowrap" flexShrink={0} position="fixed" ref={t5} zIndex={100} overflow="auto">{t7}{t9}</Box>;
    $[22] = containerTop;
    $[23] = marginLeft;
    $[24] = t4;
    $[25] = t7;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  const t11 = `${width}px`;
  let t12;
  if ($[28] !== children || $[29] !== t11) {
    t12 = <Box ml={t11} display="flex" flexDirection="column" bgcolor="white">{children}</Box>;
    $[28] = children;
    $[29] = t11;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t10 || $[32] !== t12) {
    t13 = <>{t10}{t12}</>;
    $[31] = t10;
    $[32] = t12;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  return t13;
};
function _temp(a, b) {
  return Math.abs(a?.top ?? 0) - Math.abs(b?.top ?? 0);
}